import { Card, Typography } from "@material-ui/core";
import { Timeline, TimelineItem, TimelineSeparator, TimelineDot, TimelineConnector, TimelineContent } from "@material-ui/lab";
import { FunctionComponent, memo, useEffect, useState } from "react";
import jMoment from 'moment-jalaali';
import Can from "../../../../components/Can";
import { translate } from "../../../../utils/helpers";
import { Log } from "../../../orders/interfaces";
import classes from './index.module.css'
import handleError from "../../../../utils/handleError";
import parcelLogsRepository from "client-sdk/src/Repository/parcel-logs-repository";
import { mdiMapMarkerCheckOutline, mdiClose, mdiDotsHorizontalCircleOutline, mdiClipboardCheckOutline, mdiPlaylistCheck, mdiCheckBold, mdiArrowCollapseAll, mdiFileTree, mdiClipboardArrowLeft, mdiTableArrowUp, mdiTableCheck } from "@mdi/js";
import theme from "../../../../theme";
import Icon from "@mdi/react";

interface HistoryLogProps {
  id: number
  userRole: string
}

const iconStatus = {
  ARRIVED: mdiMapMarkerCheckOutline, //'به مقصد رسیده',
  CANCELLED: mdiClose, //'لغو شده',
  SHIPPED: mdiDotsHorizontalCircleOutline, //'ارسال شده',
  DELIVERED: mdiClipboardCheckOutline, //'تحویل داده شده',
  SUBMITTED: mdiDotsHorizontalCircleOutline, //'ایجاد شده',
  ASSIGNED: mdiPlaylistCheck, // تخصیص داده شده
  REGISTERED: mdiCheckBold, //'منطبق شده',
  CONFLICTED: mdiArrowCollapseAll, // مغایرت داده شده
  LOCATED: mdiFileTree, // جایگذاری شده
  RETURNING: mdiClipboardArrowLeft, // ریجکت شده
  UNLOADING: mdiTableArrowUp, // در حال بارگذاری
  UNLOADED: mdiTableCheck, // بارگذاری شده
};
const colorStatus = {
  SUBMITTED: theme.palette.green.main, //'ثپت شده',
  SHIPPED: theme.palette.green.main, //'ارسال شده',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  REGISTERED: theme.palette.green.main, //'منطبق شده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  RETURNING: theme.palette.warning.main, //'ریجکت شده',
  UNLOADING: theme.palette.orange.main, //'در حال بارگذاری ',
  UNLOADED: theme.palette.green.main, //'بارگذاری شده',
  LOCATED: 'purple', // جایگذاری شده
  ASSIGNED: theme.palette.blue.main, // تخصیص داده شده
  CONFLICTED: theme.palette.orange.main, // مغایرت داده شده
};
 
const HistoryLog: FunctionComponent<HistoryLogProps> = ({id, userRole}) => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    getLogs(id)
  }, [])
  

  const getLogs = async (id: any) => {
    const payload = { id };
    try {
      const response = await parcelLogsRepository.getLogs({ payload });
      setLogs(response.data);
    } catch (error) {
      handleError(error);
    }
  };
  
  return ( 
    <Card style={{ marginRight: '24px', marginTop: '24px' }}>
      <Timeline align="left">
        {logs?.slice().reverse()
          .map((log: Log, index: number) => (
            <TimelineItem
              className={classes.missingOppositeContent}
              key={index}
            >
              <TimelineSeparator>
                <TimelineDot
                  style={{
                    backgroundColor: colorStatus[log.newStatus],
                    border: index === 0 ? 'solid 4px #DF9234' : '',
                  }}
                >
                  <Icon path={iconStatus[log.newStatus]} size={1} />
                </TimelineDot>
                {index !== logs?.length - 1 ? <TimelineConnector /> : ''}
              </TimelineSeparator>
              <TimelineContent className={classes.paperHistory}>
                <div style={{ padding: '10px' }}>
                  <div className={classes.contentBox}>
                    <div style={{ flex: 1, textAlign: 'right' }}>
                      <span className={classes.contentlabel}>
                        وضعیت محموله:
                      </span>
                      <span data-cy="status">
                        {translate(log.newStatus, 'parcel')}
                      </span>
                    </div>
                    <div
                      style={{
                        flex: 2,
                        textAlign: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <span className={classes.contentlabel}>
                        کاربر:
                      </span>
                      <Can
                        role={userRole}
                        perform="user-name:dontShowInLogs"
                        no={() => (
                          <>
                            <span>{log.modifierName}</span>
                            <span> &nbsp; &nbsp;- &nbsp; &nbsp;</span>
                          </>
                        )}
                      />
                      <span data-cy="role">
                        {translate(log.modifierRole, 'user')}
                      </span>
                    </div>
                    <Typography component="div" style={{ flex: 1 }}>
                      {log.time &&
                        jMoment(log.time, 'YYYY/MM/DDTHH:mm:ss.SSZ')
                          .locale('fa')
                          .format('jYYYY/jMM/jDD - HH:mm')}
                    </Typography>
                  </div>
                </div>
              </TimelineContent>
            </TimelineItem>
          ))}
      </Timeline>
    </Card>
  );
}
 
export default memo(HistoryLog);